<template>
  <v-container>
    <v-toolbar flat class="main-header mb-12 px-0">
      <v-toolbar-title class="main-header__title">
        <h1>
          <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
            >mdi-plus</v-icon
          ><v-icon v-else class="teams-icon" color="lighten-1" medium
            >mdi-pencil</v-icon
          >
          <span v-if="!isEdited">Add Sponsor</span>
          <span v-else>Edit Sponsor </span>
        </h1>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items class="main-header__contents">
        <section class="transparent-field mt-8">
          <v-switch
            v-model="form.visible"
            :true-value="1"
            :false-value="0"
            inset
            label="Make it Visible"
            color="success"
          ></v-switch>
        </section>
      </v-toolbar-items>
    </v-toolbar>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col cols="12" class="align-self-center">
            <section class="file-upload">
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.photo ? form.photo.path : ''"
                :imgId="form.photo ? form.photo.id : ''"
                @fileSelected="photoChange"
                fieldName="mainPhotoFile"
                :maxSize="maxSize"
                :reset="resetBoolean"
              />
              <!-- <p class="my-2 gray">
                <small
                  >Upload Photo <br />
                  Should be (1688 * 765)</small
                >
              </p> -->
              <!-- <template v-if="form.photo != null">
                <a
                  :href="form.photo"
                  target="_blank"
                  v-if="isEdited === true && photoBoolean"
                  class="mt-8"
                >
                  show image
                </a>
              </template> -->
            </section>
          </v-col>
          <v-col class="py-2" sm="6" cols="12">
            <form-group name="name" :attribute="`fields.name`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.name"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col sm="6" cols="12" class="py-2">
            <section class="increment-label">
              <span>Order</span>
              <number-input
                center
                v-model="form.order"
                :min="1"
                :step="1"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col class="py-0" cols="12">
            <form-group name="video" :attribute="`fields.video`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.video"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>

          <v-col cols="12">
            <span>Description</span>
            <vue-editor class="mt-2" v-model="form.description"></vue-editor>
          </v-col>
          <v-col cols="12">
            <v-btn
              class="success text-capitalize"
              large
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
import { required, maxLength, url } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";
export default {
  data() {
    return {
      form: {
        name: "",
        order: "",
        photo: "",
        visible: 0
      },
      maxSize: 2.048,
      resetLogo: false,
      Logo: false,
      Photo: false,
      stopTime: false,
      returnTime: false,
      isEdited: false,
      loadingData: false,
      globalServerErrors: null,
      photoBoolean: true,
      resetBoolean: false,
      photoChangeBoolean: false
    };
  },
  components: {
    VueEditor
  },
  created() {
    this.editCreateBoolean();
  },
  methods: {
    handleSave() {
      if (!this.isEdited) {
        this.createSponsor();
      } else {
        this.editBusStop();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `content/sponsors`,
        id: id
      })
        .then(res => {
          const { sponsor } = res.data;
          this.form = sponsor;
          if (sponsor.video != null) {
            this.form.video = sponsor.video.path;
          }
        })
        .catch(() => {});
    },
    createSponsor() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        formData.append(formItem, this.form[formItem]);
      });
      StoreData({
        reqName: `content/sponsors`,
        data: formData
      })
        .then(() => {
          this.$router.push("/content/sponsors");
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editBusStop() {
      const formData = new FormData();
      if (!this.photoChangeBoolean) {
        delete this.form.photo;
      }
      Object.keys(this.form).forEach(formItem => {
        if (this.form[formItem] != null) {
          formData.append(formItem, this.form[formItem]);
        }
      });
      formData.append("_method", "put");
      UpdateData({
        reqName: `content/sponsors`,
        data: formData,
        id: this.$route.params.id
      })
        .then(() => {
          this.isEdited = false;
          this.$router.push("/content/sponsors");

          this.reset();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    photoChange(photo) {
      this.form.photo = photo.file;
      this.photoBoolean = false;
      this.resetBoolean = false;
      this.photoChangeBoolean = true;
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "editSponsors") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(255)
      },
      video: {
        required,
        url
      },
      photo: {
        required
      },
      visible: {
        required
      },
      order: {
        required
      },
      description: {
        required
      }
    }
  }
};
</script>
